function sex(val) {
    let sex = '不限';
    switch(val){
        case 1:
            sex = '男';
            break;
        case 0:
            sex = '女';
            break;
        default:
            sex = '不限';
    }
    return sex;
}
let a = 1;
export {sex};



// WEBPACK FOOTER //
// ./src/filters/index.js